import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useQuery } from '../hooks/useQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Moment from 'moment';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import 'moment/locale/pt-br';
import AddIcon from '@mui/icons-material/Add';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import { useForm, Controller } from 'react-hook-form';
import { useSnackbar } from '../hooks/useSnackbar';

export const NovoCalendarioPage = (props) => {
  const { criarCalendario, showCalendario, atualizarCalendario } = useQuery();
  const snackbar = useSnackbar();

  const [loading, setLoading] = React.useState(false);
  const [dia, setDia] = React.useState('');
  const [mes, setMes] = React.useState('');
  const [ano, setAno] = React.useState('');
  const [permiteEnvio, setPermiteEnvio] = React.useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  let [searchParams, setSearchParams] = useSearchParams();
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  React.useEffect(() => {
    if (searchParams.get('calendario_id')) {
      getCalendario();
    }
  }, []);

  const getCalendario = async () => {
    let result = await showCalendario(searchParams.get('calendario_id'));
    if (result && result.data) {
      const { data } = result.data.data;

      const [fullDate] = data.split('T');
      const [ano, mes, dia] = fullDate.split('-');

      setDia(dia);
      setValue('dia', dia);
      setMes(mes);
      setValue('mes', mes);
      setAno(ano);
      setValue('ano', ano);
      setPermiteEnvio(result.data.data.permite_envio === 'S');
    }
  };

  const salvar = async () => {
    setLoading(true);

    try {
      const result = await criarCalendario({
        data: `${ano}-${mes}-${dia}`,
        permite_envio: permiteEnvio ? 'S' : 'N',
      });
      if (result && result.data) {
        navigate('/dashboard/listar-calendario');
      }
    } catch (error) {
      snackbar.showSnackbar(error.response.data.message);
    }

    setLoading(false);
  };

  const atualizar = async () => {
    setLoading(true);

    try {
      const result = await atualizarCalendario(
        searchParams.get('calendario_id'),
        {
          data: `${ano}-${mes}-${dia}`,
          permite_envio: permiteEnvio ? 'S' : 'N',
        },
      );

      if (result && result.data) {
        navigate('/dashboard/listar-calendario');
      }
    } catch (error) {
      snackbar.showSnackbar(error.response.data.message);
    }

    setLoading(false);
  };

  const onSubmit = () => {
    if (dia != undefined && mes != undefined && ano != undefined) {
      if (searchParams.get('calendario_id')) {
        atualizar();
      } else {
        salvar();
      }
    }
  };

  const envio = () => {};
  const onErrors = () => {};

  const onChangeDia = (event) => {
    setDia(event.target.value);
  };

  const onChangeMes = (event) => {
    setMes(event.target.value);
  };

  const onChangeAno = (event) => {
    setAno(event.target.value);
  };

  const onChangePermiteEnvio = (event) => {
    setPermiteEnvio(event.target.checked);
  };

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                  mr: 1,
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Criar novo calendário
              </span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <form onSubmit={handleSubmit(envio, onErrors)}>
        <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
          <Grid item sm={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Dia</InputLabel>
              <Controller
                name="dia"
                id="dia"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Select
                    labelId="demo-simple-select-label"
                    id="dia"
                    size="small"
                    value={dia}
                    label="dia"
                    onChange={(event) => {
                      onChange(event);
                      onChangeDia(event);
                    }}
                  >
                    <MenuItem value={'01'}>01</MenuItem>
                    <MenuItem value={'02'}>02</MenuItem>
                    <MenuItem value={'03'}>03</MenuItem>
                    <MenuItem value={'04'}>04</MenuItem>
                    <MenuItem value={'05'}>05</MenuItem>
                    <MenuItem value={'06'}>06</MenuItem>
                    <MenuItem value={'07'}>07</MenuItem>
                    <MenuItem value={'08'}>08</MenuItem>
                    <MenuItem value={'09'}>09</MenuItem>
                    <MenuItem value={'10'}>10</MenuItem>
                    <MenuItem value={'11'}>11</MenuItem>
                    <MenuItem value={'12'}>12</MenuItem>
                    <MenuItem value={'13'}>13</MenuItem>
                    <MenuItem value={'14'}>14</MenuItem>
                    <MenuItem value={'15'}>15</MenuItem>
                    <MenuItem value={'16'}>16</MenuItem>
                    <MenuItem value={'17'}>17</MenuItem>
                    <MenuItem value={'18'}>18</MenuItem>
                    <MenuItem value={'19'}>19</MenuItem>
                    <MenuItem value={'20'}>20</MenuItem>
                    <MenuItem value={'21'}>21</MenuItem>
                    <MenuItem value={'22'}>22</MenuItem>
                    <MenuItem value={'23'}>23</MenuItem>
                    <MenuItem value={'24'}>24</MenuItem>
                    <MenuItem value={'25'}>25</MenuItem>
                    <MenuItem value={'26'}>26</MenuItem>
                    <MenuItem value={'27'}>27</MenuItem>
                    <MenuItem value={'28'}>28</MenuItem>
                    <MenuItem value={'29'}>29</MenuItem>
                    <MenuItem value={'30'}>30</MenuItem>
                    <MenuItem value={'31'}>31</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item sm={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Mes</InputLabel>
              <Controller
                name="mes"
                id="mes"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="mes"
                    value={mes}
                    label="Mes"
                    onChange={(event) => {
                      onChange(event);
                      onChangeMes(event);
                    }}
                  >
                    <MenuItem value={'01'}>Janeiro</MenuItem>
                    <MenuItem value={'02'}>Fevereiro</MenuItem>
                    <MenuItem value={'03'}>Março</MenuItem>
                    <MenuItem value={'04'}>Abril</MenuItem>
                    <MenuItem value={'05'}>Maio</MenuItem>
                    <MenuItem value={'06'}>Junho</MenuItem>
                    <MenuItem value={'07'}>Julho</MenuItem>
                    <MenuItem value={'08'}>Agosto</MenuItem>
                    <MenuItem value={'09'}>Setembro</MenuItem>
                    <MenuItem value={'10'}>Outubro</MenuItem>
                    <MenuItem value={'11'}>Novembro</MenuItem>
                    <MenuItem value={'12'}>Dezembro</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item sm={3}>
            <FormControl fullWidth>
              <Controller
                name="ano"
                id="ano"
                control={control}
                render={({
                  field: { value },
                  fieldState: { error, message },
                }) => (
                  <TextField
                    value={ano}
                    type="number"
                    placeholder="Ano"
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .substring(0, 4)
                        .replace(/[^0-9.]/g, '');
                      setAno(e.target.value);
                    }}
                    inputProps={{
                      min: 4,
                      maxLength: 4,
                    }}
                    error={error}
                    helperText={error && error.message}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item sm={3}>
            <FormControl component="fieldset" variant="standard">
              <FormLabel component="legend">Permitir Envio</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={permiteEnvio}
                      onChange={onChangePermiteEnvio}
                    />
                  }
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item sm={12} style={{ paddingTop: 20 }}>
            <Button onClick={onSubmit} variant="contained">
              Salvar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
